const pageNameKey = "ticketsTaskbarCard";

export const ticketsTaskbarCardEn = {
  [pageNameKey]: {
    altCloseIcon: "Patch ticket",
    errorFetchingTicket: "Error fetching ticket information for ID: ",
  },
};

export const ticketsTaskbarCardPtBr = {
  [pageNameKey]: {
    altCloseIcon: "Ticket de correção",
    errorFetchingTicket: "Erro ao buscar informações do ticket para o ID: ",
  },
};

export const ticketsTaskbarCardDe = {
  [pageNameKey]: {
    altCloseIcon: "Ticket aktualisieren",
    errorFetchingTicket: "Fehler beim Abrufen der Ticketinformationen für ID: ",
  },
};

export const ticketsTaskbarCardZhHans = {
  [pageNameKey]: {
    altCloseIcon: "更新工单",
    errorFetchingTicket: "获取工单信息时出错，ID: ",
  },
};

export const ticketsTaskbarCardIt = {
  [pageNameKey]: {
    altCloseIcon: "Aggiorna ticket",
    errorFetchingTicket:
      "Errore durante il recupero delle informazioni per il ticket (ID): ",
  },
};

export const ticketsTaskbarCardEs = {
  [pageNameKey]: {
    altCloseIcon: "Parche de ticket",
    errorFetchingTicket: "Error al obtener la información del ticket para ID: ",
  },
};

export const ticketsTaskbarCardNl = {
  [pageNameKey]: {
    altCloseIcon: "Ticket bewerken",
    errorFetchingTicket: "Fout bij het ophalen van ticketinformatie voor ID: ",
  },
};

export const ticketsTaskbarCardTr = {
  [pageNameKey]: {
    altCloseIcon: "Yama bileti",
    errorFetchingTicket: "Kimlik için bilet bilgileri alınırken hata oluştu:",
  },
};
